import { DOMAINS } from './selectLists/contriesList'

export const ROUTE_PARAMS = {
  partnership: 'partnership',
  selfAccount: 'selfAccount',
  platform: 'platform',
  adAccount: 'adAccount',
  campaignId: 'campaign_id',
  lineItemId: 'line_item_id',
  rightId: 'right_id'
}

const SETTINGS = '/settings'
export const SETTINGS_ROUTES = {
  MY_INFORMATION: 'my-information',
  PARTNER_ACCOUNTS: 'partner-accounts',
  PARTNERSHIPS: 'partnerships',
  PAGES_AND_IDENTITIES: 'pages-and-identities',
  MARGINS: 'margins',
  MANAGE_PARTNER_TEAM: 'manage-partner-team',
  MANAGE_LOCATION_LISTS: 'manage-location-lists',
  HELP: 'help',
  ON_SITE_AD_SERVER: 'on-site-ad-server',
  RIGHT_HOLDER_PROFILE: 'right-holder-profile',
  AUDIENCES: 'audiences'
}

export const authorisationCallbackUrl = 'authorise-callback'

const getPlatformUrl = () => {
  const currentAppUrl = window.location.href

  if (currentAppUrl.includes(DOMAINS.crowdcatch)) {
    return 'https://crowdcatch.cricket.com.au'
  } else {
    return 'https://partnerbrite.com'
  }
}

// routes should not include trailing slash "/" in the end
export const ROUTES = {
  platformDomain: getPlatformUrl(),

  themeSelector: '/theme-selector',

  // auth
  login: '/login',
  acceptInvite: '/accept-invite',
  resetPassword: '/reset-password', // request password reset
  createPassword: '/create-password', // create password after signup
  forgotPassword: '/forgot-password', // set password after reset password request
  resendRegister: '/resend-register',

  // invites accept/decline page
  invites: '/invites',

  partnerships: `/:${ROUTE_PARAMS.partnership}/partnerships`,
  chat: `/:${ROUTE_PARAMS.partnership}/chat`,
  socialReturnOnInvestment: `/:${ROUTE_PARAMS.partnership}/social-return-on-investment`,
  rightsSummary: `/:${ROUTE_PARAMS.partnership}/partnerships/rights/:${ROUTE_PARAMS.rightId}`,
  // campaigns
  campaigns: `/:${ROUTE_PARAMS.partnership}/:${ROUTE_PARAMS.platform}/campaigns`,
  campaignsSummary: `/:${ROUTE_PARAMS.partnership}/:${ROUTE_PARAMS.platform}/:${ROUTE_PARAMS.adAccount}/campaigns/:${ROUTE_PARAMS.campaignId}`,

  // other
  lineItemsSummary: `/:${ROUTE_PARAMS.partnership}/:${ROUTE_PARAMS.platform}/:${ROUTE_PARAMS.adAccount}/campaigns/:${ROUTE_PARAMS.campaignId}/lineitem/:${ROUTE_PARAMS.lineItemId}`,
  adApprovals: `/:${ROUTE_PARAMS.partnership}/:${ROUTE_PARAMS.platform}/ad-approvals`,
  authorisePlatformCallback: `/:${ROUTE_PARAMS.platform}/${authorisationCallbackUrl}`,
  adAccountAccessMissing: `/:${ROUTE_PARAMS.partnership}/:${ROUTE_PARAMS.platform}/:${ROUTE_PARAMS.adAccount}/ad-account-access-missing`,
  selector: `/:${ROUTE_PARAMS.partnership}/selector`,

  // settings
  settings: `/:${ROUTE_PARAMS.partnership}${SETTINGS}`,
  myInformation: `/:${ROUTE_PARAMS.partnership}${SETTINGS}/${SETTINGS_ROUTES.MY_INFORMATION}`,
  partnerAccounts: `/:${ROUTE_PARAMS.partnership}${SETTINGS}/${SETTINGS_ROUTES.PARTNER_ACCOUNTS}`,
  pagesAndIdentities: `/:${ROUTE_PARAMS.partnership}${SETTINGS}/${SETTINGS_ROUTES.PAGES_AND_IDENTITIES}`,
  settingsMargins: `/:${ROUTE_PARAMS.partnership}${SETTINGS}/${SETTINGS_ROUTES.MARGINS}`,
  onSiteAdServer: `/:${ROUTE_PARAMS.partnership}${SETTINGS}/${SETTINGS_ROUTES.ON_SITE_AD_SERVER}`,
  settingsPartnerships: `/:${ROUTE_PARAMS.partnership}${SETTINGS}/${SETTINGS_ROUTES.PARTNERSHIPS}`,
  managePartnerTeam: `/:${ROUTE_PARAMS.partnership}${SETTINGS}/${SETTINGS_ROUTES.MANAGE_PARTNER_TEAM}`,
  managePresets: `/:${ROUTE_PARAMS.partnership}${SETTINGS}/${SETTINGS_ROUTES.MANAGE_LOCATION_LISTS}`,
  help: `/:${ROUTE_PARAMS.partnership}${SETTINGS}/${SETTINGS_ROUTES.HELP}`,
  rightHolderProfile: `/:${ROUTE_PARAMS.partnership}${SETTINGS}/${SETTINGS_ROUTES.RIGHT_HOLDER_PROFILE}`,
  audiences: `/:${ROUTE_PARAMS.partnership}${SETTINGS}/${SETTINGS_ROUTES.AUDIENCES}`
}
